// Nepali diplomatic missions abroad + selected foreign missions in Kathmandu.
// Official embassy pages cited. Verify before travel.
import { LAST_VERIFIED } from './officialSources';

export const NEPAL_MISSIONS_ABROAD = [
	{
		country: 'Germany',
		city: 'Berlin',
		name: 'Embassy of Nepal, Berlin',
		address: 'Guerickestrasse 27 (2nd Floor), 10587 Berlin-Charlottenburg',
		phone: '+49 (030) 343599-20',
		email: 'berlin@nepalembassy.de',
		url: 'https://de.nepalembassy.gov.np/',
		visaNote: 'Issues tourist, diplomatic, and official visas. Most European nationals including Germans can also obtain visa on arrival at TIA.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'United States',
		city: 'Washington DC',
		name: 'Embassy of Nepal, Washington DC',
		address: '2131 Leroy Place NW, Washington, DC 20008',
		phone: '+1 (202) 667-4550',
		url: 'https://us.nepalembassy.gov.np/',
		visaNote: 'US citizens pay visa fees per reciprocity (not gratis under-10 rule). VOA available at TIA for tourism.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'United Kingdom',
		city: 'London',
		name: 'Embassy of Nepal, London',
		address: '12A Kensington Palace Gardens, London W8 4QU',
		phone: '+44 (0)20 7229 1594',
		url: 'https://uk.nepalembassy.gov.np/',
		visaNote: 'British nationals eligible for visa on arrival at TIA and land entry points.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'India',
		city: 'New Delhi',
		name: 'Embassy of Nepal, New Delhi',
		address: 'Barakhambha Road, New Delhi 110001',
		phone: '+91 11 2338 2712',
		url: 'https://in.nepalembassy.gov.np/',
		visaNote: 'Indian nationals do not need a tourist visa for Nepal. Other nationalities apply here for pre-arrival visas.',
		voaEligible: null,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'China',
		city: 'Beijing',
		name: 'Embassy of Nepal, Beijing',
		address: 'San Li Tun, Beijing',
		url: 'https://cn.nepalembassy.gov.np/',
		visaNote: 'Chinese nationals receive gratis tourist visa on arrival per reciprocity arrangements.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'Australia',
		city: 'Canberra',
		name: 'Embassy of Nepal, Canberra',
		url: 'https://au.nepalembassy.gov.np/',
		visaNote: 'Australian nationals eligible for visa on arrival. Confirm current fees on immigration.gov.np.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'France',
		city: 'Paris',
		name: 'Embassy of Nepal, Paris',
		url: 'https://fr.nepalembassy.gov.np/',
		visaNote: 'French and EU nationals eligible for visa on arrival at TIA.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'Japan',
		city: 'Tokyo',
		name: 'Embassy of Nepal, Tokyo',
		url: 'https://jp.nepalembassy.gov.np/',
		visaNote: 'Japanese nationals eligible for visa on arrival.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'South Korea',
		city: 'Seoul',
		name: 'Embassy of Nepal, Seoul',
		url: 'https://kr.nepalembassy.gov.np/',
		visaNote: 'South Korean nationals eligible for visa on arrival.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
	{
		country: 'Canada',
		city: 'Ottawa',
		name: 'Embassy of Nepal, Ottawa',
		url: 'https://ca.nepalembassy.gov.np/',
		visaNote: 'Canadian nationals eligible for visa on arrival at TIA.',
		voaEligible: true,
		lastVerified: LAST_VERIFIED,
	},
];

export const FOREIGN_MISSIONS_KATHMANDU = [
	{ country: 'Germany', name: 'German Embassy Kathmandu', url: 'https://kathmandu.diplo.de/' },
	{ country: 'United States', name: 'US Embassy Kathmandu', url: 'https://np.usembassy.gov/' },
	{ country: 'United Kingdom', name: 'British Embassy Kathmandu', url: 'https://www.gov.uk/world/organisations/british-embassy-kathmandu' },
	{ country: 'India', name: 'Embassy of India, Kathmandu', url: 'https://www.indianembassynepal.gov.in/' },
	{ country: 'China', name: 'Embassy of China, Kathmandu', url: 'https://np.china-embassy.gov.cn/' },
	{ country: 'Australia', name: 'Australian Embassy Kathmandu', url: 'https://nepal.embassy.gov.au/' },
	{ country: 'France', name: 'French Embassy Kathmandu', url: 'https://np.ambafrance.org/' },
	{ country: 'Japan', name: 'Embassy of Japan, Kathmandu', url: 'https://www.np.emb-japan.go.jp/' },
];
